import ClickAwayListener from '@mui/material/ClickAwayListener';
import Paper from '@mui/material/Paper';
import makeStyles from '@mui/styles/makeStyles';
import EntryListMenuButton from './EntryListMenuButton';

const useStyles = makeStyles((theme) => ({
    menuRoot: {
        [theme.breakpoints.up('sm')]: {
            position: "relative",
        }
    },
    paper: {
        width: '100%',
    },
    menuWrap: {
        [theme.breakpoints.up('lg')]: {
            position: 'absolute',
            top: "100%",
            right: 0,
        }
    },
    menu: {
        //display:"none",
        opacity: 0,
        pointerEvents: "none",
        position: 'absolute',
        transform: "scale(0)",
        transformOrigin: "top center",
        transition: `opacity 255ms cubic-bezier(0.4, 0, 0.2, 1), transform 1000ms cubic-bezier(0.4, 0, 0.2, 1)`,
        left: 0, right: 0,
        width: `100%`,
        minWidth: 100,

        [theme.breakpoints.up('sm')]: {
            minWidth: 250,
            left: "unset",
            transformOrigin: "top right",
        }, 
    },
    menuOpen: {
        display: "block",
        opacity: 1,
        pointerEvents: "initial",
        transform: "scale(1)",
        transition: `opacity 255ms cubic-bezier(0.4, 0, 0.2, 1), transform 170ms cubic-bezier(0.4, 0, 0.2, 1)`,
    },
}));

export default function MainFilterDropdownMenuWithButton({ children, anchorRef, open, handleToggle = ()=>{}, handleClose = ()=>{}, buttonIcon, buttonLabel, }) {
    const classes = useStyles();

    return (
        <ClickAwayListener 
            onClickAway={() => { open && handleToggle(); }}
        >
            <div className={classes.menuRoot}>
                <EntryListMenuButton
                    open={open}
                    anchorRef={anchorRef}
                    label={buttonLabel}
                    icon={buttonIcon}
                    onClick={handleToggle}
                />
                    <div className={classes.menuWrap}>
                        <Paper className={[classes.menu, (open ? classes.menuOpen : "")].join(" ")}>
                            {children}
                        </Paper>
                    </div>
            </div>
        </ClickAwayListener>
    );
}